// extracted by mini-css-extract-plugin
module.exports = {"contact-page":"styles_contact-page__29vgf"};